import sc from 'styled-components';
import {Button} from '@phonectas/unifon-ui-kit';

export const StyledUpsellButton = sc(Button)`
    background-color: #FFECC6;
    align-items: center;
    padding: 10px 16px;
	gap: 6px;

    &:hover {
        background-color: #a3d6a2; // #c8e6c7
        border-color: #bbb;
    }
	
	p {
		font-weight: normal !important;
	}
`;
